/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/StarClubCollectionMenu',[
		'lodash',
		'pixi',
		'absolute',
		'absolute/stringmanager',
		'absolute/screenmetrics',
		'MenuUI/Menu',
		'MenuUI/StarClubChallengePackTile',
		'Solitaire/MvvmStructure/Service/SolitaireStarClubService',
		'MenuUI/ControlFocusManager',
		'MenuUI/BadgeEarnedDialog',
		'MenuUI/SideBar',
		'Managers/StatManager',
		'util/SettingsManager',
		'Managers/ScaleManager',
		'Managers/ScrollManager'
	],
	function (_, PIXI, Absolute, _s, ScreenMetrics, Menu, StarClubChallengePackTile, SolitaireStarClubService, ControlFocusManager,
	          FUEDialog, SideBar, StatManager, SettingsManager, ScaleManager, ScrollManager) {
		"use strict";

		var StarClubCollectionMenu = function (ui, game) {
			this.initStarClubCollectionMenu(ui, game);
		};

		StarClubCollectionMenu.constructor = StarClubCollectionMenu;
		StarClubCollectionMenu.prototype = Object.create(Absolute.Screen.prototype);

		StarClubCollectionMenu.prototype.initStarClubCollectionMenu = function (ui, game) {
			Absolute.Screen.call(this);
			this.ui = ui;
			this.game = game;

			var background = PIXI.Sprite.fromFrame('win10_MS_bg.png');
			this.background.addChild(background);

			this.controlFocusManager = new ControlFocusManager();

			this.clickHandler = this.handleGameInput.bind(this);

			this.container = new PIXI.DisplayObjectContainer();

			window.addEventListener('click', this.clickHandler);
			ScaleManager.addElement(this, {scaleChangeSource: 'Full'});

		};

		StarClubCollectionMenu.prototype.initSidebar = function () {
			this.sidebar = new SideBar({
				availableHeight: 200, partialHeight: 100,
				onScrollUpdate: function (p) {
				}.bind(this)
			});
			this.addChild(this.sidebar);
			this.sidebar.position.set(Absolute.Coords.x(1900), Absolute.Coords.y(67));
			this.updateSidebar();
		};

		StarClubCollectionMenu.prototype.initTouchInterface = function () {
			// Dragging and panning
			this.lastDeltaY = 0;
			this.startY = 0;
			var hitArea = new PIXI.Rectangle(0, 0, Absolute.Coords.x(1920), Absolute.Coords.y(1080));
			this.touchContainer = new PIXI.DisplayObjectContainer();
			this.touchContainer.interactive = true;
			this.touchContainer.hitArea = hitArea;
			this.touchContainer.addChild(this.scrollable);
			this.touchContainer.mousedown = this.touchContainer.touchstart = this.handleDragStart.bind(this);
			this.touchContainer.mousemove = this.touchContainer.touchmove = this.handleDrag.bind(this);
			this.touchContainer.mouseupoutside = this.touchContainer.mouseup = this.touchContainer.touchend = this.touchContainer.touchendoutside = this.handleDragEnd.bind(this);
			this.addChild(this.touchContainer);
		};

		StarClubCollectionMenu.prototype.handleDragStart = function (data) {
			this.dragging = true;
			this.lastDeltaY = 0;
			this.startY = data.getLocalPosition(this.parent).y;
			this.enableButtons(false);
		};

		StarClubCollectionMenu.prototype.handleDrag = function (data) {

			if (!this.dragging) {
				return;
			}

			var pos = data.getLocalPosition(this.parent),
				delta = pos.y - this.startY;

			this.scrollTo(this.scrollable.y + ((delta - this.lastDeltaY)));

			this.lastDeltaY = delta;
		};

		StarClubCollectionMenu.prototype.handleDragEnd = function (data) {

			if (!this.dragging) {
				return;
			}
			this.dragging = false;
		};

		StarClubCollectionMenu.prototype.enableButtons = function (enable) {

			var i, l;

			for (i = 0, l = this.scrollable.children.length; i < l; i++) {
				this.scrollable.children[i].interactive = enable;
			}

		};

		StarClubCollectionMenu.prototype.doScroll = function (e) {
			if (!this.scrollable) return;
			if (this.scrollableFakeHeight <= Absolute.Coords.y(1080)) {
				this.scrollable.y = 0;
				return;
			}
			var deltaY = 0;
			if (!e) e = window.event;
			if (e.wheelDelta) {
				deltaY = e.wheelDelta / 35;
			} else if (e.detail) {
				deltaY = -e.detail / 3;
			}
			this.scrollTo(this.scrollable.y + (deltaY * 100));
		};

		StarClubCollectionMenu.prototype.scrollTo = function (y, scroller) {
			if (!this.scrollable) return;
			if (this.scrollableFakeHeight <= Absolute.Coords.y(1080)) {
				this.scrollable.y = 0;
				return;
			}
			this.scrollable.y = y;
			if (this.scrollable.y > 0) this.scrollable.y = 0;
			var posY = this.scrollableFakeHeight - Absolute.Coords.y(1080);
			if (Math.abs(this.scrollable.y) > posY) {
				this.scrollable.y = -posY;
			}
			if (this.sidebar) this.sidebar.updateHandleByPercent(100 * Math.abs(this.scrollable.y) / Math.abs(posY));
			this.challengePackTiles.forEach(function (tile) {
				tile.hideTooltip(tile.infoBoxContainer, tile);
			})
		};

		StarClubCollectionMenu.prototype.startScrolling = function (delta) {
			this.sidebar.updateByArrow(delta);
		};

		StarClubCollectionMenu.prototype.updateSidebar = function () {
			if (!this.sidebar || !this.scrollable) return;
            var height = this.game.menuBar.menuBarHeight;

            var resizeScale = 1;
            if (Absolute.Platform.isMobile()) {
                height *= 0.7;
                if (Absolute.ScreenMetrics.isPortrait()) {
                    resizeScale = 0.5;
                }
            }

			var screenScaleX = ScaleManager.width / Absolute.Coords.x(1920),
				screenScaleY = ScaleManager.height / Absolute.Coords.y(1080);
			this.sidebar.scale.set(1, 1);
            this.sidebar.width = this.sidebar.width / screenScaleX * resizeScale;
			this.sidebar.height = this.sidebar.height / screenScaleY;
			this.sidebar.y = height / screenScaleY;
			this.sidebar.x = Absolute.Coords.x(1900) - (this.sidebar.width - (this.sidebar.width * screenScaleX));
			var availableHeight, partialHeight, posY;
			availableHeight = this.scrollableFakeHeight;
			partialHeight = Absolute.Coords.x(1080);
			posY = availableHeight - Absolute.Coords.y(1080);
			this.sidebar.resetDimensions(availableHeight, partialHeight, function (p) {
				var y = -Math.abs(posY) * p / 100;
				this.scrollable.y = y;
				if (this.scrollable.y > 0) this.scrollable.y = 0;
				if (Math.abs(this.scrollable.y) > posY) {
					this.scrollable.y = -posY;
				}
			}.bind(this), (ScaleManager.height - height));
			this.sidebar.visible = (partialHeight < availableHeight);
			this.sidebar.updateHandleByPercent(100 * Math.abs(this.scrollable.y) / Math.abs(posY));
		};

		StarClubCollectionMenu.prototype.initTouchContainer = function () {

		};

		StarClubCollectionMenu.prototype.afterRender = function (collection) {
		};

		StarClubCollectionMenu.prototype.loadCollection = function (collection) {

			while (this.container.children.length > 0) {
				this.container.removeChildAt(0);
			}

			this.challengePackTiles = [];

			this.controlsGroupMap = {'StarClubPacks': []};

			_.forEach(collection.ChallengePacks, function (challengePack) {
				var tileData = {
					userData: challengePack,
					image: challengePack.icon,
					icon: '',
					label: _s(challengePack.Name),
					action: null,
					letterStyle: {
						font: Absolute.ScreenMetrics.getResScale() * 23 + 'px Arial',
						fontFamily: 'segoe',
						fill: '#ffffff',
						tint: 0xffffff,
						align: 'left'
					},
					iconPosition: {
						x: 0,
						y: 0
					},
					labelPosition: {
						x: Absolute.Coords.x(88),
						y: Absolute.Coords.y(50)
					},
					labelPadding: Absolute.Coords.y(50),
					labelOffset: Absolute.Coords.y(22),
					dropShadow: true,
					hoverBox: true
				};

				tileData.action = this.onChallengePackSelected.bind(this);

				var challengePackTile = new StarClubChallengePackTile(tileData, challengePack, this);
				this.challengePackTiles.push(challengePackTile);
				this.controlsGroupMap['StarClubPacks'].push(challengePackTile)
			}, this);
			this.collectionName = collection.CollectionGroupName;
			this.label = Absolute.StringManager(collection.Name);
			var menuConfig = _.extend({
				'tiles': this.challengePackTiles,
				'keepOneLine': true
			}, ScaleManager.scaleParams['MenuConfigs']['SCCollectionMenuConfigs']);

			this.currentWidth = Absolute.Coords.x(1820);
			this.scrollable = new PIXI.DisplayObjectContainer();

			this.challengePackMenu = new Menu(_.extend(menuConfig, ScaleManager.scaleParams['SCChallengePacks'][this.collectionName]));

			this.container.addChild(this.challengePackMenu);

			this.scrollable.addChild(this.container);
			this.addChild(this.scrollable);
			this.scrollable.width = this.currentWidth;

			this.updatePagesPositions();

			this.initTouchInterface();
			this.handleResize();
		};

		StarClubCollectionMenu.prototype.handleResize = function () {
			if (!this.scrollable) return;
			this.scrollTo(this.scrollable.y);
			this.container.y = (this.game.menuBar.menuButton.y + this.game.menuBar.menuButton.height)
				* (this.container.width * this.container.children[0].pageGenerator.cardScale / ScaleManager.width) * (ScaleManager.height / Absolute.Coords.y(985));
			this.updatePagesPositions();
			this.challengePackTiles.forEach(function (tile) {
				tile.resizeInfoBoxContainer();
			}.bind(this));
			this.scrollable.height = (this.currentWidth / this.container.width) * (Absolute.Coords.y(985) / ScaleManager.height)
				* (ScaleManager.width / Absolute.Coords.x(1840)) * this.currentHeight;
			this.scrollable.width = this.currentWidth;
			this.scrollableFakeHeight = this.scrollable.height + Absolute.Coords.x(110);
			if ((this.scrollable.y < 0) && ((this.scrollableFakeHeight + this.scrollable.y) < Absolute.Coords.y(1080))) {
				this.scrollable.y = Absolute.Coords.y(1080) - this.scrollableFakeHeight;
			}
			this.updateSidebar();
		};

		StarClubCollectionMenu.prototype.updatePagesPositions = function () {
			var prevChild, scale = Math.max(this.container.width / this.currentWidth, 0.7),
				xPos = Absolute.Coords.x(100) * scale, yGap = Absolute.Coords.y(70) * scale,
				startY = Absolute.Coords.y(60) * scale;
			this.currentHeight = Absolute.Coords.y(185);
			this.container.children.forEach(function (c) {
				c.x = xPos;
				c.y = prevChild ? prevChild.y + prevChild.height + yGap : startY;
				this.currentHeight += c.height + (prevChild ? yGap : 0);
				prevChild = c;
			}.bind(this));
		};

		StarClubCollectionMenu.prototype.onShow = function (isPortrait) {

			Absolute.Screen.prototype.onShow.call(this);
			ScrollManager.add(this, this.doScroll, this);
			SolitaireStarClubService.UpdateGlobalStarClubStats();

			this.addChild(this.game.menuBar);
			this.game.menuBar.onShow(true, true, true, this.label);
			this.ui.refreshBackground = true;

			this.challengePackMenu.onShow();

			this.checkForUnlockableChallengePack();

			this.initControls();

			if (!this.sidebar) this.initSidebar();
			this.addChild(this.sidebar);
			this.scrollTo(0);
			this.handleResize();
		};

		StarClubCollectionMenu.prototype.initControls = function () {
			this.controlFocusManager.addControl(this.game.menuBar.controlGroup[0], false, 'LeftButtons');
			this.controlFocusManager.addControl(this.game.menuBar.controlGroup[1], false, 'LeftButtons');
			this.controlFocusManager.addControl(this.game.menuBar.controlGroup[2], false, 'RightButtons');
			if (this.game.menuBar.fullScreenEnabled) {
				this.controlFocusManager.addControl(this.game.menuBar.controlGroup[3], false, 'RightButtons');
			}
			for (var key in this.controlsGroupMap) {
				if (this.controlsGroupMap.hasOwnProperty(key)) {
					for (var i = 0; i < this.controlsGroupMap[key].length; i++) {
						this.controlFocusManager.addControl(this.controlsGroupMap[key][i], false, key);
					}
				}
			}
		};

		StarClubCollectionMenu.prototype.onHide = function () {
			this.controlFocusManager.removeAllControls();
			this.sectionSelected = false;
			this.currentPageIndex = 0;
			this.challengePackMenu.onHide();
			Absolute.Screen.prototype.onHide.call(this);
			ScrollManager.remove(this);
		};

		StarClubCollectionMenu.prototype.onChallengePackSelected = function (challengePack) {
			if (challengePack.Unlocked) {
				SolitaireStarClubService.currentPack = challengePack;
				this.game.navStarClubChallenge(challengePack);
			}
		};

		StarClubCollectionMenu.prototype.showLockedWarning = function (amountNeeded, type) {
			this.ui.showWarning(_s("dialogs.needMoreStarsTitle"), _s("dialogs.needMoreStarsContent", [amountNeeded, type]));
		};

		StarClubCollectionMenu.prototype.handleCommand = function (command, isMouseWheel) {
			if (isMouseWheel) return;
			this.selectSection(command, isMouseWheel);
			switch (command) {
				case 'Right': {
					if (!this.sectionSelected) return;
					this.controlFocusManager.focusNextControl(1);
					break;
				}
				case 'Left': {
					if (!this.sectionSelected) return;
					this.controlFocusManager.focusNextControl(-1);
					break;
				}
				case 'Up': {
					this.controlFocusManager.focusNextControl(-1);
					break;
				}
				case 'Down': {
					this.controlFocusManager.focusNextControl(1);
					break;
				}
				case 'Activate':
					this.controlFocusManager.activateCurrentControl();
					break;
				case 'Unfocus':
					this.controlFocusManager.unfocusCurrentControl();
					break;
			}
		};

		StarClubCollectionMenu.prototype.selectSection = function (command, isMouseWheel) {
			if (command === 'Tab' || command === 'ShiftTab') {
				this.controlFocusManager.focusCurrentControl();
				this.sectionSelected = true;
				if (command === 'Tab') {
					if (this.page === 2) {
						this.handlePageChange(this.page, 0);
						this.page = 0;
					} else {
						this.controlFocusManager.nextFocusGroup();
					}
				} else if (command === 'ShiftTab') {
					if (this.page === 0) {
						this.handlePageChange(this.page, 2);
						this.page = 2;
					} else {
						this.controlFocusManager.prevFocusGroup();
					}
				}
				switch (this.controlFocusManager.currentFocusGroup) {
					case 'LeftButtons':
						this.page = 0;
						break;
					case 'RightButtons':
						this.page = 1;
						break;
					case 'StarClubPacks':
						this.page = 2;
						break;
				}
			}
		};

		StarClubCollectionMenu.prototype.handlePageChange = function (from, to) {
			switch (to) {
				case 0:
					this.controlFocusManager.setFocusGroup('LeftButtons');
					break;
				case 1:
					this.controlFocusManager.setFocusGroup('RightButtons');
					break;
				case 2:
					this.controlFocusManager.setFocusGroup('StarClubPacks');
					break;
			}
		};

		StarClubCollectionMenu.prototype.checkForUnlockableChallengePack = function () {
			if (!SettingsManager.getSetting('general', 'showSCFUE3')) {
				return;
			}

			var fue3Open = false;

			_.each(this.challengePackTiles, function (challengePackTile) {
				if (fue3Open) {
					return;
				}
				if (challengePackTile.challengePack && !challengePackTile.challengePack.Unlocked &&
					StatManager.GetValue("SCGlobalStarsEarned") >= challengePackTile.challengePack.PriceOfUnlocking) {
					ScrollManager.disableScroll();
					var fue3 = new FUEDialog(this.ui, this.game,
						{
							offsetX: Absolute.Coords.x(10),
							offsetY: Absolute.Coords.x(10),
							dialog: 'SC-FUE-3',
							width: Absolute.Coords.x(1300),
							closeHandler: function () {
								ScrollManager.enableScroll();
							}
						});

					SettingsManager.setSetting('general', 'showSCFUE3', false);
					fue3.open();
					fue3Open = true;
					return;
				}
			}, this);
		};

		StarClubCollectionMenu.prototype.handleGameInput = function () {
			this.resetControlManager();
		};

		StarClubCollectionMenu.prototype.resetControlManager = function () {
			this.controlFocusManager.unfocusCurrentControl();
			this.sectionSelected = false;
		};

		return StarClubCollectionMenu;

	});

